import {useRef} from 'react';

function useLateStart(isPresent: boolean, startedAt: number) {
  const lateRef = useRef<number | null>(null);

  if (isPresent && lateRef.current === null) {
    lateRef.current = (Date.now() - startedAt) / 1000;
  }

  return lateRef.current ?? 0;
}

function delayAfter(base: number, late: number) {
  return `${Math.max(0, base - late).toFixed(2)}s`;
}

export {delayAfter, useLateStart};
